/** Who made a dashboard or a chart, as the API names them. */
export type Person = {
  id: string;
  /** Full name, else email; null when the account no longer exists. */
  name: string | null;
  isYou: boolean;
};

/**
 * The quiet "Created by …" line under a dashboard's title, beside it in the
 * switcher, and under each card.
 *
 * One function for all three, so a dashboard and the cards on it can never
 * describe the same person two different ways.
 */
export const createdByLine = (
  t: (key: string, options?: Record<string, unknown>) => string,
  language: string,
  person: Person,
  isoDate?: string | null
): string => {
  const parsed = isoDate ? new Date(isoDate) : null;
  const date =
    parsed && !Number.isNaN(parsed.getTime())
      ? parsed.toLocaleDateString(language, { dateStyle: 'medium' })
      : null;

  if (person.isYou) {
    return date
      ? t('Created by you · {{date}}', { date })
      : t('Created by you');
  }
  const name = person.name ?? t('a former member');
  return date
    ? t('Created by {{name}} · {{date}}', { name, date })
    : t('Created by {{name}}', { name });
};
